import React from 'react';
import { RouteRedirect } from 'modules/routing-module';

export const EditorDraft: React.FC = () => (
  <RouteRedirect routeKey="EditorCreate" />
);
